// helpers
import * as d3 from 'd3';
import { wrapLongLabels } from './utils/helpers';

// styles
import './styles/graphic.scss';


export default function (props, container, isMobile) {
  const {
    colorScale,
    data,
    height,
    initialWidth,
    initialHeight,
    keys,
    margins,
    // width,
    xAxis,
    x,
    yAxis,
    y0,
    y1,
  } = props;

  // const latestValue = d => `${Number(d.value)}`;
  const xTicks = isMobile ? 2 : 4;
  const [min, max] = x.domain();

  // going with a legend in the chart label?
  const legend = container.append('ul')
    .attr('class', 'key')
    .selectAll('li')
    .data(keys)
    .enter()
    .append('li')
    .attr('class', 'key-item');

  legend.append('span')
    .attr('class', 'key-block')
    .style('background-color', d => colorScale(d));

  legend.append('label')
    .text(d => d.replace(/_/g, ' '));

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('role', 'presentation')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .ticks(xTicks)
      .tickFormat(d3.format('$.2~s'))
      .tickSize(-height));

  xGrid.selectAll('text')
    .attr('y', 6);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .attr('role', 'presentation')
    .call(yAxis(y0));

  yGrid.selectAll('text')
    .text('');

  //  adding in candidate names and photos

  const candidateGroup = g.selectAll('g.candidateGroup')
    .data(data)
    .enter()
    .append('g')
	  .attr('class', 'candidate-group');

  const candidateMeta = candidateGroup.append('g')
    .attr('class', 'candidate-meta');

  // moved around titles and names for mobile

  if (!isMobile) {
    candidateMeta.append('text')
      .attr('class', 'candidate-name')
      .attr('y', 40)
      .text(d => d.committee)
      .call(wrapLongLabels, 100);
  }

  if (!isMobile) {
    candidateMeta.append('text')
      .attr('class', 'candidate-title')
      .attr('dy', 82)
      .attr('dx', -130)
      .text(d => d.name);
  }

  if (isMobile) {
    candidateMeta.append('text')
      .attr('class', 'candidate-name')
      .attr('y', 30)
      .text(d => d.committeeshort)
      .call(wrapLongLabels, 80);
  }

  if (isMobile) {
    candidateMeta.append('text')
      .attr('class', 'candidate-title')
      .attr('y', 85)
      .attr('dx', -100)
      .text(d => d.lastname);
  }

  // if (isMobile) {
  //   candidateMeta.append('text')
  //     .attr('class', 'candidate-title')
  //     .attr('dy', 70)
  //     .attr('dx', 0)
  //     .text(d => d.lastname);
  // }

  if (!isMobile) {
    candidateMeta.append('image')
      .attr('class', 'candidate-photo')
      .attr('href', d => `./assets/${d.photo}`)
      .attr('dy', 10)
      .attr('x', -160);
  }

  if (isMobile) {
    candidateMeta.append('image')
      .attr('class', 'candidate-photo')
      .attr('href', d => `./assets/${d.photo}`)
      .attr('y', 10)
      .attr('x', -130);
  }

  candidateMeta
    .attr('transform', (d, i) => `translate(-5, ${y0(d.committee)})`);

  // candidateGroup.selectAll('text')
  //   .attr('transform', 'translate(-5,0)')
  //   .call(wrapLongLabels, margins.left);


  //	  const candidate = candidateContainer.selectAll('div')
  //	    .data(data)
  //	    .enter().append('div')
  //	    .attr('class', 'candidate')
  //	    .style('top', (d, i) => `${i * height}px`);
  //
  //  	const meta = candidate.append('div')
  //  		.attr('class', 'candidate-meta');
  //
  //  	meta.append('img')
  //  		.attr('src', 	d => imgURL(nameGenerator(d.Group.split(' ').filter((d, i) => i > 0)//.join(' '))));
  //
  //  	const metaInfo = meta.append('div')
  //  		.attr('class', 'candidate-meta-info');
  //
  //  	metaInfo.append('h3')
  //    .text(d => (isMobile ? d.name.split(' ').filter((d, i) => i > 0).join(' ') : d.name));
  //
  //  	metaInfo.append('h5')
  //  		.text(d => d.title);
  //
  // end speaking times stuff

  const groups = g.append('g')
    .attr('class', 'data')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'bars')
    .attr('transform', d => `translate(${[0, y0(d.committee)]})`);

  const bars = groups.selectAll('g')
    .data(d => keys.map(key => ({ key, value: d[key] })))
    .enter().append('g')
    .attr('class', 'bar')
    .attr('transform', d => `translate(${[x(Math.min(0, d.value)), y1(d.key)]})`);

  bars.append('rect')
    .attr('width', d => Math.abs(x(0) - x(d.value)))
    .attr('height', y1.bandwidth())
    .style('fill', d => colorScale(d.key));


  bars.append('text')
    .attr('x', d => (d.value < 0 ? 0 : Math.abs(x(0) - x(d.value))))
    .attr('y', y1.bandwidth() / 2)
    .attr('class', 'bar-labels')
    .attr('dx', d => ((d.value < 0 && Math.abs(d.value / min) < 0.85) || (d.value / max > 0.85) ? -5 : 5))
    .attr('dy', '.32em')
    .attr('text-anchor', d => ((d.value < 0 && Math.abs(d.value / min) < 0.85) || (d.value / max > 0.85) ? 'end' : 'start'))
    // .text(d3.format('$,.2r')(d => `${Number(d.value)}`));
    // .text(d => `$${Number(d.value)}`);
    // .text(d => `$${d3.format(',.3s')(d.value).replace('k', 'K')}`);
    .text((d) => {
      if (d.value < 1000000) {
        // For values less than a million
        return `$${d3.format(',.1f')(d.value / 1000)}K`;
      }
      // For values more than a million
      return `$${d3.format(',.1f')(d.value / 1000000)}M`;
    });


  if (min < 0) {
    g.append('line')
      .attr('x1', x(0))
      .attr('x2', x(0))
      .attr('y2', height)
      .attr('class', 'zero-bar');
  }
}
